var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitterX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.117 5.082 11.488.001h-1.036L6.657 4.413 3.625 0H.13l4.584 6.672L.13 12h1.036l4.008-4.66 3.201 4.66h3.497L7.117 5.082zm-1.419 1.65-.464-.665L1.538.781H3.13l2.983 4.266.464.664 3.877 5.546H8.862L5.698 6.732z",
    fill: "#020842"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .001)",
    d: "M0 0h12v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitterX);
export default __webpack_public_path__ + "static/media/icon_twitter_x.6b30eb120ebce4eb82a8397165dd1b76.svg";
export { ForwardRef as ReactComponent };